export default __webpack_public_path__ + "static/media/banner10.afd8c3e0.svg";